import React, { useEffect } from "react";
import { Stack, Grid, Flex, Text, Group } from "@mantine/core";

declare global {
  interface Window {
    AgentInitializer: {
      init: (config: Record<string, unknown>) => void;
    };
  }
}

const JotformBot: React.FC = () => {
  useEffect(() => {
    // Dynamically load the external script
    const script = document.createElement("script");
    script.src = "https://cdn.jotfor.ms/s/umd/latest/for-embedded-agent.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      // Initialize the chatbot after the script loads
      window.AgentInitializer.init({
        agentRenderURL:
          "https://www.jotform.com/agent/019474b4dc147bd7866c06d1e2775b469297",
        rootId: "JotformAgent-019474b4dc147bd7866c06d1e2775b469297",
        formID: "019474b4dc147bd7866c06d1e2775b469297",
        queryParams: ["skipWelcome=1", "maximizable=1"],
        domain: "https://agent.jotform.com",
        isInitialOpen: false,
        isDraggable: false,
        background: "linear-gradient(180deg, #C8CEED 0%, #C8CEED 100%)",
        buttonBackgroundColor: "#0a1551",
        buttonIconColor: "#fff",
        variant: false,
        customizations: {
          greeting: "Yes",
          greetingMessage: "Hi! How can I assist you?",
          pulse: "Yes",
          position: "right",
        },
        isVoice: false,
      });
    };

    return () => {
      // Cleanup the script when the component is unmounted
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Flex className="w-full h-full flex flex-col justify-center items-center">
      <div id="JotformAgent-019474b4dc147bd7866c06d1e2775b469297"></div>
    </Flex>
  );
};

export default JotformBot;
